module.exports = __webpack_public_path__ + "main/images/shared/save-content@3x.3ec94439e39898917f092f343fa73379.png";